module.exports = __webpack_public_path__ + "static/people-two-69317b1f5a2f681b7f45ba91b9ce0c3d.jpg";